import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sendProjectRequest } from '../../../../store/actions/projectActions'

class JoinProjectModal extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    sendProjectRequest = () => {
        const { proid, userData } = this.props;
        var requestMakerJson = {
            uid: userData.uid,
        };

        var projectModelJson = {
            proid,
        }

        this.props.sendProjectRequest(requestMakerJson, projectModelJson);
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle } = this.props;
        return (
            <div style={{ width: `${modalWidth}` }}>
                <p style={modalTitleStyle}>Accept terms:</p>
                <p style={modalInfoTextStyle}>* You must comply with your company's terms and our terms.</p>
                <p style={modalInfoTextStyle}>* You must note that you can be removed by either your company or by AssetTag on any misconduct.</p>
                <p style={modalInfoTextStyle}>* If you are found distributing QR code without permission and compliance.</p>
                <br />
                <div className="btn btn-danger btn-sm float-right" onClick={() => this.sendProjectRequest()}>I accept and send request</div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidthMedium: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        proid: state.project.proid,

        userData: state.firebase.profile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        sendProjectRequest: (requestMakerJson, projectModelJson) => dispatch(sendProjectRequest(requestMakerJson, projectModelJson)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(JoinProjectModal)